module.exports = __webpack_public_path__ + "static/img/tv.38dac220.png";